export default __webpack_public_path__ + "static/media/project7.4e851cda.JPG";